import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["list", "required", "disabled", "type", "value", "placeholder"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "invalid-feedback order-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", {
      class: _normalizeClass(["form-control", _ctx.returnIfExists(_ctx.statTypeEnum.Design) + ' ' + _ctx.validate()]),
      list: _ctx.object.Stats[_ctx.statTypeEnum.BelongsTo].Data,
      required: _ctx.attributeCheck(_ctx.statTypeEnum.Required),
      disabled: _ctx.disabledCheck(_ctx.statTypeEnum.Disabled),
      type: _ctx.returnIfExists(_ctx.statTypeEnum.ElementType),
      value: `${_ctx.object?.Stats[_ctx.statTypeEnum.Value].Data !== null ? _ctx.object.Stats[_ctx.statTypeEnum.Value].Data.name === undefined ? _ctx.valueName : _ctx.object.Stats[_ctx.statTypeEnum.Value].Data.name : ''}`,
      placeholder: _ctx.returnIfExists(_ctx.statTypeEnum.Placeholder),
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.inputEvent(_ctx.object as ObjectTemplate, $event.target.value)))
    }, null, 42, _hoisted_1),
    (_ctx.displayOptions)
      ? (_openBlock(), _createElementBlock("datalist", {
          key: 0,
          id: _ctx.object.Stats[_ctx.statTypeEnum.BelongsTo].Data
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: option.name
            }, _toDisplayString(option.name), 9, _hoisted_3))
          }), 128))
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.returnIfExists(_ctx.statTypeEnum.ErrorMessage)), 1)
  ], 64))
}